import { Skeleton } from '@nextui-org/react-latest'

const GroupedButtonsLoading = [...Array(9)].map((i, n) => (
  <Skeleton className="w-32 h-[27px] rounded-full" key={`${i}-${n}`} />
))

export default GroupedButtonsLoading
